namespace TabAurous.Common {
    export namespace GetItemRateService {
        export const baseUrl = 'Common/GetItemRate';


        export declare const enum Methods {

        }

    }
}
